import { render } from "./UsersViewTable.vue?vue&type=template&id=30d17aab&scoped=true"
import script from "./UsersViewTable.vue?vue&type=script&lang=js"
export * from "./UsersViewTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d17aab"]])

export default __exports__